/* Mstrel - browser ZOOM detection.

   CSS cannot tell a wide monitor from a zoomed-out window: to a media query,
   "3840px monitor at 100%" and "1920px monitor at 50%" are the same thing.
   That is why a plain min-width:1441px rule also boxed in people whose normal
   monitor is simply wide - the client saw grey bars at 100% zoom.

   JavaScript CAN tell, because outerWidth (the window's real size in device
   pixels) does not change when you zoom, while innerWidth (the CSS viewport)
   does:  innerWidth / outerWidth  ~= 1.0 at 100%, ~1.25 at 80%, ~2.0 at 50%.

   We only add the class when the user has ACTUALLY zoomed out (<= ~85%) AND the
   viewport is wider than the 1440 design canvas. Everything else - every phone,
   tablet, laptop and large monitor at normal zoom - is left completely alone. */
(function(){
  var d = document.documentElement;
  function update(){
    var z = window.outerWidth ? (window.innerWidth / window.outerWidth) : 1;
    var on = (z > 1.15) && (window.innerWidth > 1440);
    if (d.classList.toggle) d.classList.toggle('mstrel-zoomout', on);
  }
  try{ update(); }catch(e){}
  window.addEventListener('resize', update, {passive:true});
  window.addEventListener('orientationchange', update, {passive:true});
  window.addEventListener('pageshow', update, {passive:true});
})();
